import { Component, OnInit } from '@angular/core';
import { BalanceModel } from 'src/app/models/balance-model';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { EventsService } from 'src/app/services/event/event.service';
import { FundsIndicatorService } from 'src/app/services/funds-indicator/funds-indicator.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { Navigator } from '../../menu/navigator';

@Component({
  selector: 'app-navbar-deposit',
  templateUrl: './navbar-deposit.component.html',
  styleUrls: ['./navbar-deposit.component.scss'],
})

export class NavbarDepositComponent implements OnInit {

  public showBalance: boolean = true;
  public balance: any;
  code: any;
  codeText: string;

  constructor(
    public accountBalanceService: AccountBalanceService,
    public eventsService: EventsService,
    public navigator: Navigator,
    public fundsIndicatorService: FundsIndicatorService,
    public userSessionService: UserSessionService
  ){
    this.showBalance = fundsIndicatorService.showBalance;

    this.eventsService.subscribe("event:balanceState",  data => this.updateBalanceState(data));
  }

  ngOnInit(){
    this.verifyAuth();
  }

  private verifyAuth(): any {
    return this.userSessionService.isAuthenticated().then((isAuthenticated) => {
      if(!!isAuthenticated) this.getBalance();
    });
  }

  private getBalance(){
    this.accountBalanceService.getBalance().subscribe((response: BalanceModel) =>{
      this.balance = response; 
    });
  }

  public updateBalanceState(data) {
    this.showBalance = data.show;
    
    this.code = (!isUndefined(data.code)) ? data.code : "";
    if(this.code === 'IN_GAME') {this.codeText = "IN GAME";return this.showBalance = false};
    if(this.code === 'IN_DEMO') {this.codeText = "IN DEMO";return this.showBalance = false};
  }

  public navigateTo(pageName){
    return this.navigator.navigateTo(pageName);
  }

}
